import { type ComponentType } from "react";

type FixedProps<Props> = Partial<Props> & {
  [key: `data-${string}`]: string;
};

export const withFixedProps = <Props extends object>(
  Component: ComponentType<Props>,
  fixedProps: FixedProps<Props>,
): ComponentType<Props> => {
  const FixedPropsComponent = (props: Props) => (
    <Component {...props} {...fixedProps} />
  );

  return FixedPropsComponent;
};
